import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-validation-error-label',
    template: `<mat-icon svgIcon="error"></mat-icon>
        <span class="text-small"> {{ message }}</span>`,
    styleUrls: ['./validation-error-label.component.scss'],
    standalone: false
})
export class ValidationErrorLabelComponent {
    @Input()
    message: string;
}
